module.exports = __webpack_public_path__ + "static/media/AUS.30afc159.jpg";